import React from 'react';

export const LazyIotDistributePage = React.lazy(() => import('./IotDistributePage'));
export const LazyIotDevicePage = React.lazy(() => import('./IotDevicePage'));
export const LazyAlterHistoryPage = React.lazy(() => import('./AlterHistoryPage'));
export const LazyEnvSensorPage = React.lazy(() => import('./EnvSensorPage'));
